// Moved from `src/hooks/query/useQueryOrganization.ts` (now the delegate)
// with OT3 (ARCFE-954). Token-seam severance (the entitlements precedent) +
// the ARCFE-921 mechanism for the toast: the legacy catch ran console.error →
// toast → return null, so the `onFetchError` port fires between the log and
// the null-swallow, and the delegate owns the translated copy. The
// null-return (no rethrow) is frozen behaviour — preserved, not improved.
import { useQuery } from '@tanstack/react-query';

import { GET_ORGANIZATION_BY_ORGANIZATION_ID } from '../../contracts/keys';
import { getOrganizationByOrganizationId } from '../api/organization';
import { getWorkspaceDataConfig } from '../config';
import { useQueryUser } from './useQueryUser';

export { GET_ORGANIZATION_BY_ORGANIZATION_ID };

interface UseQueryOrganizationByIdOptions {
  /** App-reaction port: fired where the legacy toast fired (ARCFE-921). */
  onFetchError?: (error: unknown) => void;
}

export function useQueryOrganizationById(
  organizationId?: string,
  isGlobalAdmin?: boolean,
  options?: UseQueryOrganizationByIdOptions
) {
  const token = getWorkspaceDataConfig().useAuthToken();
  const { data: userData } = useQueryUser();
  return useQuery({
    queryKey: [GET_ORGANIZATION_BY_ORGANIZATION_ID, { organizationId }],
    retry: 3,
    enabled: !!token && !!userData && !!organizationId && isGlobalAdmin,
    queryFn: async () => {
      try {
        if (!organizationId) {
          return null;
        }
        const { data } = await getOrganizationByOrganizationId(organizationId);
        return data;
      } catch (error) {
        console.error(error);
        options?.onFetchError?.(error);
        return null;
      }
    },
  });
}
